import React from 'react';
import { FiMail, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const NewsletterSignup = () => {
  return (
    <div className="py-8">
      <h2 className="text-2xl font-bold mb-6 text-gray-900">Nyhetsbrev</h2>
      <div className="w-full bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-8 border border-orange-200">
        <div className="text-center max-w-2xl mx-auto">
          <div className="w-16 h-16 bg-[#F28423] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
            <SafeIcon icon={FiMail} className="w-8 h-8 text-white" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">Prenumerera på vårt nyhetsbrev</h3>
          <p className="text-gray-600 mb-8 text-lg">
            Få de senaste insikterna om digitalisering, nya avsnitt och exklusivt innehåll direkt i din inkorg.
          </p>
          <a
            href="https://sendfox.com/form/10e8yx/mpreey"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#F28423] hover:bg-orange-600 text-white px-8 py-4 rounded-full font-bold transition-all transform hover:scale-105 active:scale-95 shadow-xl"
          >
            <span>Prenumerera nu</span>
            <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </a>
          <p className="text-xs text-gray-500 mt-4">
            Det är gratis och du kan avsluta när som helst.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewsletterSignup;